export default "__VITE_ASSET__Mh3YTHo2__"